import styled from '@emotion/styled';
import { Button, Form, Input, notification } from 'antd';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { ConnectedUserEntity } from '../../../../entities/ConnectedUserEntity';
import { PartenaireEntity } from '../../../../entities/partenaire.entity';
import { ORANGE } from '../../../../shared/colors';
import { createPartenaire } from '../network';

const FormShell = styled.div`
  color: var(--mt-text);

  .form-intro {
    border: 1px solid var(--mt-border);
    border-radius: 8px;
    margin-bottom: 16px;
    padding: 14px;
    background:
      linear-gradient(135deg, rgba(255, 79, 31, 0.1), transparent 42%),
      var(--mt-surface);
  }

  .form-intro span {
    color: var(--mt-warning);
    font-family: Poppins-B;
    font-size: 11px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .form-intro h3 {
    margin: 5px 0 0;
    color: var(--mt-text);
    font-family: Poppins-B;
  }

  .ant-form-item-label label {
    color: var(--mt-muted);
    font-family: Poppins-B;
    font-size: 12px;
    text-transform: uppercase;
  }

  .ant-input {
    height: 42px;
    border-color: var(--mt-border);
    border-radius: 8px;
    background: var(--mt-surface);
    color: var(--mt-text);
  }

  .submit-button {
    min-width: 180px;
    height: 42px;
    border: 0;
    border-radius: 999px;
    background: linear-gradient(135deg, ${ORANGE}, #ffb000);
    color: #07141c;
    font-family: Poppins-B;
  }
`;

export const PartenaireForm = ({
  setShowDrawer,
  getNewPartenaire,
}: {
  setShowDrawer: (b: boolean) => void;
  getNewPartenaire: (part: PartenaireEntity) => void;
}) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const connectedUser = new ConnectedUserEntity(
    useSelector((state: any) => state.userReducer).user,
  );

  return (
    <FormShell>
      <div className='form-intro'>
        <span>Nouveau partenaire</span>
        <h3>{connectedUser?.manager?.nom || 'MoranjETrade'}</h3>
      </div>
      <Form
        layout='vertical'
        style={{ listStyleType: 'none' }}
        form={form}
        labelCol={{ span: 20 }}
        wrapperCol={{ span: 25 }}
        initialValues={{
          type: 'Banque',
        }}
        onFinish={async (data) => {
          setIsLoading(true);
          data.manager = connectedUser.manager.url;

          await createPartenaire(data).then(({ data, statusCode }) => {
            if (statusCode?.toString()[0] === '2') {
              notification.success({
                message: 'Succès',
                description: 'Le partenaire a été créé avec succès',
              });
              getNewPartenaire(data);
              setShowDrawer(false);
            } else {
              notification.info({
                message: 'Erreur',
                description: data.message,
              });
            }
            setIsLoading(false);
          });
        }}
      >
        <Form.Item
          label='Nom du partenaire'
          name='nom'
          hasFeedback
          rules={[
            {
              required: true,
              message: 'Entrez le nom du partenaire',
            },
          ]}
        >
          <Input placeholder='Entrez le nom du partenaire' />
        </Form.Item>
        <Form.Item
          label='Localisation'
          name='localisation'
          hasFeedback
          rules={[
            {
              required: true,
              message: 'Entrez la localisation',
            },
          ]}
        >
          <Input placeholder='Entrez la localisation' />
        </Form.Item>
        <Form.Item
          label='Code référent'
          name='code_referent'
          hasFeedback
          rules={[
            {
              required: true,
              message: 'Entrez le code référent',
            },
          ]}
        >
          <Input placeholder='Entrez le code référent' />
        </Form.Item>
        <Form.Item
          label='Type'
          name='type'
          hasFeedback
          rules={[
            {
              required: true,
              message: 'Entrez la type de partenaire',
            },
          ]}
          extra={<i>Banque, SVT, Particulier...</i>}
        >
          <Input placeholder='Entrez la type de partenaire' />
        </Form.Item>
        <Form.Item>
          <Button
            htmlType='submit'
            className='submit-button'
            loading={isLoading}
          >
            Enregistrer
          </Button>
        </Form.Item>
      </Form>
    </FormShell>
  );
};
